// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://bzbpobcdbqdufbhquzvz.supabase.co';
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ6YnBvYmNkYnFkdWZiaHF1enZ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM2ODQ2NzcsImV4cCI6MjA4OTI2MDY3N30.DA1wtLNu8F-APN6ursdOJY6Ew6xgm79RkelGPBduIuw"

export const supabase = createClient(supabaseUrl, supabaseAnonKey);